<div class="main-breadcrumb-wrapper">
   <p-breadcrumb 
      [model]="items" 
      styleClass="custom-breadcrumb">
      <ng-template pTemplate="item" let-item>
         <a [routerLink]="item.routerLink" *ngIf="!item.disabled">
            {{ item.label | translate }}
         </a>
         <span *ngIf="item.disabled" class="current-item">
            {{ item.label | translate }}
         </span>
      </ng-template>
      <ng-template pTemplate="separator">
         <!-- <span class="separator">❯</span> -->
      </ng-template>
   </p-breadcrumb>
</div>